import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
  aed,
  configureMoney,
  currencyFromUser,
  currentCurrency,
  money,
  money2,
  moneyStep,
  roundOffToUnit,
} from "@/lib/format";

/**
 * Company currency + decimals from auth (kept in sync with format.js defaults).
 */
export function useCurrency() {
  const { user } = useAuth();
  const { code, decimals } = currencyFromUser(user);

  configureMoney({ code, decimals });

  return useMemo(() => {
    const format = (n) => money(n, code, decimals);
    const formatPlain = (n) => money2(n, code, decimals);
    const formatWithCode = (n) => `${money2(n, code, decimals)} ${code}`;
    return {
      code,
      decimals,
      format,
      formatPlain,
      formatWithCode,
      step: moneyStep(decimals),
      aed: format,
      money2: formatPlain,
      roundOff: (n) => roundOffToUnit(n, code),
      current: currentCurrency,
    };
  }, [code, decimals]);
}

export { aed, money, money2, roundOffToUnit };
